var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92682 1.69531C4.55609 1.69531 1 5.1741 1 9.44981C1 13.7258 4.55609 17.2043 8.92682 17.2043C13.2978 17.2043 16.8536 13.7258 16.8536 9.44981C16.8536 5.1741 13.2978 1.69531 8.92682 1.69531ZM8.92682 15.7727C5.36293 15.7727 2.46341 12.9363 2.46341 9.44985C2.46341 5.96343 5.36293 3.12691 8.92682 3.12691C12.4907 3.12691 15.3902 5.96339 15.3902 9.44981C15.3902 12.9362 12.4907 15.7727 8.92682 15.7727Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 18.0812L14.5905 13.9773C14.3046 13.6977 13.8417 13.6977 13.5558 13.9773C13.27 14.2567 13.27 14.7101 13.5558 14.9895L17.751 19.0934C17.8939 19.2332 18.081 19.3031 18.2683 19.3031C18.4554 19.3031 18.6427 19.2332 18.7856 19.0934C19.0715 18.814 19.0715 18.3606 18.7856 18.0812Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eb0a288e02fb290704713389321362a7.svg";
export { ForwardRef as ReactComponent };